import styles from "./styles.module.scss";
import Button from "src/components/button";
import cx from "classnames";
import { useHubAdoption } from "src/redux/actions/adoption/hub";

const chromeExtAlert = "/images/chromeExtAlert_Bg.png"

const ChromeExtAlertBanner = ({classname, onClose}: {classname?: string, onClose: () => void}) => {

    const { trackChromeExtensionDownloadClickedEvent} = useHubAdoption();

    const openChromeExt = () => { //open chrome extension link
      trackChromeExtensionDownloadClickedEvent();
      
      // open link in new tab
      const url = "https://chromewebstore.google.com/detail/gghdahjgeomeiohiecmfmdomeighihih?utm_source=item-share-cb";
      window.open(url, "_blank");
      
    }

    return (
        <div className={cx(styles.container, classname)}>
            <img src={chromeExtAlert} className={styles.imageContainer}/>
            <div className={styles.contentContainer}>
                <div className={styles.content}>
                    <p> The new AI Paperflite Extension: Ask SEEK, access your content hub, share content and prep for meetings right in your workflow.</p>
                    <Button
                    text={"Download"}
                    variant="primary"
                    onClick={openChromeExt}
                    className={styles.downloadButton}    
                    icon="paperflite-download"/>
                </div>
                <i className={cx('paperflite-close', styles.closeIcon)}  onClick={onClose} />           
            </div>
        </div>
    )
}

export default ChromeExtAlertBanner;